import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        checkoutMainGaps: {
            gap: {base: 'small.base', sm: 0, md: 0, lg: 'small.lg', xl: remCalc(142)},
        },
        toggleCardBox: {
            //py: {base: 0, lg: remCalc(24)},
            textStyle: 'body-medium',
            flexDirection: 'column',
        },
        toggleIconBox: {
            w: remCalc(24),
            backgroundColor: 'text.success',
            borderRadius: '50%',
            mr: remCalc(8),
        },
        ToggleCardStack: {
            gap: {base: 0},
        },
        toggleCheckIcon: {
            boxSize: 'iconsSize.medium',
            color: 'text.inverse',
            w: remCalc(24),
        },
        billingACBox: {
            border: 'small',
            borderColor: 'border.dark',
            borderStyle: 'solid',
            padding: remCalc(20),
            maxWidth: {base: '100%', md: '100%', lg: remCalc(450)},
        },
        insideflex: {
            gap: remCalc(16),
            alignItems: 'center',
            cursor: 'pointer',
        },
        billingACFlex: {
            mb: remCalc(8),
            gap: remCalc(16),
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        useLabel: {
            textStyle: 'body-small',
            fontWeight: 'bold',
        },
        billingRadioGap: {ml: remCalc(24)},
        billingAddressTypeGap: {marginBottom: remCalc(40)},
        billingAddressTypeStack: {gap: remCalc(24), mb: remCalc(48)},
        shippingLoadingContainer: {
            flexDirection: 'column',
            gap: remCalc(24),
        },
        shippingLoading: {
            w: '100%',
            paddingTop: remCalc(54),
            position: 'relative',
        },
        giftContainer: {
            mb: remCalc(24),
        },
        giftMainFlex: {
            gap: remCalc(24),
            flexDirection: 'column',
        },
        giftCheckboxFlex: {
            gap: remCalc(16),
            flexDirection: 'column',
        },
        giftDescription: {
            textStyle: 'body-xsmall',
            color: 'text.secondary',
            mt: remCalc(8),
        },
        shippingLabel: {
            textStyle: 'body-small',
            color: 'text.default',
            pb: remCalc(24),
            pt: remCalc(12),
        },
        giftTextContainer: {
            mt: remCalc(8),
        },
        giftCheckboxText: {
            textStyle: 'body-small',
        },
        optionsApplicableShippings: {
            flexDirection: 'column',
            gap: remCalc(4),
        },
        optionsApplicableShippingsText: {
            textStyle: 'body-small',
        },
        optionsApplicableShippingsDesc: {
            textStyle: 'body-small',
            color: 'text.secondary',
        },
        optionsApplicableShippingsPrice: {
            textStyle: 'body-small',
            color: 'text.success',
            textTransform: 'uppercase',
        },
        optionsShippingRegister: {
            textStyle: 'body-xsmall',
            color: 'text.secondary',
            mt: remCalc(8),
        },
        optionsShippingSummary: {
            border: 'small',
            borderColor: 'border.light',
            borderStyle: 'solid',
            padding: remCalc(20),
            maxWidth: {base: '100%', md: '100%', lg: remCalc(450)},
            marginBottom: remCalc(24),
        },
        optionsShippingColumn: {
            flexDirection: 'column',
            gap: remCalc(8),
            textStyle: 'body-medium',
        },
        optionsStrong: {
            fontWeight: 'bold',
        },
        optionsSuccess: {
            textStyle: 'body-small',
            color: 'text.success',
            textTransform: 'uppercase',
            display: 'inline',
        },
        hideAdditionalInfoCardOnMobile: {
            flexDirection: 'column',
            gap: remCalc(8),
            display: {base: 'none', lg: 'flex'},
        },
        hideAdditionalInfoCardOnDesktop: {
            flexDirection: 'column',
            gap: remCalc(8),
            display: {base: 'flex', lg: 'none'},
            order: {base: 1, lg: 0},
        },
        'is-editing': {
            border: 'none',
            padding: 0,
        },
        gapCard: {
            gap: remCalc(16),
        },
        summaryShipping: {
            paddingBottom: remCalc(24),
        },
        subscriptionsCheckoutContainer: {
            height: 'auto',
            display: 'grid',
            gridTemplateColumns: {base: '1fr', lg: '1fr 1fr'},
        },
        registerAccountTitle: {
            textStyle: 'head-medium',
            fontWeight: 500,
            color: 'text.default',
            marginBottom: {base: remCalc(16), md: remCalc(24)},
            width: '100%',
        },
    },
    variants: {
        checkout: {
            toggleCardBox: {
                py: remCalc(24),
            },
        },
        options: {
            toggleCardBox: {
                py: 0,
            },
        },
        'profile-card': {
            toggleCardBox: {
                border: 'small',
                borderStyle: 'solid',
                borderRadius: 'large.base',
                borderColor: 'border.light',
                padding: remCalc(24),
                maxWidth: '100%',
            },
            ToggleCardStack: {
                position: 'relative',
                gap: {base: remCalc(40), lg: 0},
                flexDirection: {base: 'column-reverse', lg: 'row'},
                justifyContent: 'space-between',
            },
            gapCard: {
                padding: 0,
            },
            boxContent: {
                display: 'flex',
                gap: {base: 0, lg: remCalc(24)},
                w: '100%',
            },
            editButton: {
                textStyle: 'body-small',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                fontWeight: 400,
                position: 'absolute',
                right: {lg: 0}, // remCalc(24)
                top: {lg: 0}, // remCalc(24)
                bottom: {sm: 0, lg: 'unset'},
                // left: {sm: remCalc(24), lg: 'unset'},
                marginBottom: {sm: 0},
            },
            toggleCardEditModal: {
                content: {
                    margin: {base: remCalc(16), md: 'auto'},
                },
                header: {},
                body: {
                    padding: {base: remCalc(16), md: remCalc(24)},
                },
            },
        },
        'edit-card': {
            border: 'none',
            padding: 0,

            boxContent: {
                display: 'flex',
                flexDirection: 'column',
                gap: {base: 0, lg: remCalc(24)},
                w: '100%',
            },
        },
    },
}
